
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cart49ktQJeNt_45nuXcLfTg0wibIlYyikUNFgmnb4bduCS9oMeta } from "/opt/buildhome/repo/pages/cart.vue?macro=true";
import { default as swagk7l4LGQFrHgAh_45q_q_4577yyy9QWqK3TLo1S8UJBdpDusMeta } from "/opt/buildhome/repo/pages/swag.vue?macro=true";
import { default as about6Vgf2e_45ZWwa_45DDxcsm2LFgKBFkBxwt_su_XdCkSeybIMeta } from "/opt/buildhome/repo/pages/about.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as luresXVyFaaOGPFGeEvt9OMyCg_45S9E6UFFjqh5zLLTIPw870Meta } from "/opt/buildhome/repo/pages/lures.vue?macro=true";
import { default as canceluubUY2sfESjrSxKrksSiQHq4Dz6XrUGkoTYZYUs8T0QMeta } from "/opt/buildhome/repo/pages/cancel.vue?macro=true";
import { default as detailst8mS3IAWFeMF5LQXv8F_BIrEfipKPf0BDfMdQUaxPx0Meta } from "/opt/buildhome/repo/pages/details.vue?macro=true";
import { default as successbb2HmaztMe8tGtjjLR_hVh4hGNH_45AwpDPHcjkE1WtpUMeta } from "/opt/buildhome/repo/pages/success.vue?macro=true";
import { default as checkoutIe3ZCYBfE0_eVJtM1LwepQWKGXxfXpMBIyaOCzPKyxMMeta } from "/opt/buildhome/repo/pages/checkout.vue?macro=true";
export default [
  {
    name: "cart",
    path: "/cart",
    component: () => import("/opt/buildhome/repo/pages/cart.vue")
  },
  {
    name: "swag",
    path: "/swag",
    component: () => import("/opt/buildhome/repo/pages/swag.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/buildhome/repo/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "lures",
    path: "/lures",
    component: () => import("/opt/buildhome/repo/pages/lures.vue")
  },
  {
    name: "cancel",
    path: "/cancel",
    meta: canceluubUY2sfESjrSxKrksSiQHq4Dz6XrUGkoTYZYUs8T0QMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cancel.vue")
  },
  {
    name: "details",
    path: "/details",
    component: () => import("/opt/buildhome/repo/pages/details.vue")
  },
  {
    name: "success",
    path: "/success",
    meta: successbb2HmaztMe8tGtjjLR_hVh4hGNH_45AwpDPHcjkE1WtpUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/success.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/opt/buildhome/repo/pages/checkout.vue")
  }
]